export default "__VITE_ASSET__e804444b__"